export default "__VITE_ASSET__BQWQ97Hk__"